<template>
  <b-modal
    id="kanbangivefdbck"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    size="md"
    :visible="isGiveFeedback"
    @hidden="hideGiveFeed"
  >
    <div class="w-100">
      <div class="p-3 d-flex justify-content-between align-items-center">
        <div class="pff-modal-heading">Give Feedback</div>
        <div class="pointer" @click="hideGiveFeed">
          <img
            class="rotate-on-hover"
            src="../../../assets/img/feedbackform/x-close.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <hr class="m-0" />
    <div class="kanban-fdbck-content-container">
      <div class="kanban-recomm-container p-3">
        <div class="kanban-gf-head">Select Feedback type</div>
        <div
          class="allocateradios d-flex align-items-ce nter mt-3 give-feed-radio"
        >
          <b-form-radio
            v-if="selectedProcess.type == 'assesment'"
            class="mr-3"
            v-model="feedbackType"
            value="eval"
            @change="changeType()"
            >Evaluate Assessment</b-form-radio
          >
          <b-form-radio
            v-model="feedbackType"
            value="upload"
            @change="changeType()"
          >
            Upload Feedback</b-form-radio
          >
          <b-form-radio
            v-model="feedbackType"
            value="fill"
            class="ml-3"
            @change="changeType()"
          >
            Fill Feedback
          </b-form-radio>
          <!-- !botInterview &&  -->
          <b-form-radio
            :disabled="botInterview"
            v-if="selectedProcess.type == 'f2f' || selectedProcess.id == 'F'"
            v-model="feedbackType"
            value="remainder"
            class="ml-3"
          >
            Reminder
          </b-form-radio>
        </div>
      </div>
      <!-- reminder option starts -->
      <template v-if="feedbackType == 'remainder' && remainder">
        <template v-if="remainders.length == 0">
          <div class="mt-3 ml-3">
            <div class="reminder-head-txt mb-2">Panelist</div>
            <div
              class="
                createjob-ip-evaluators
                d-flex
                flex-wrap
                mt-1
                align-items-center
              "
              v-for="panel in panelistArray"
              :key="panel.value"
            >
              {{ panel.text }}
            </div>
          </div>
          <div
            class="
              mt-3
              d-flex
              flex-column
              align-items-center
              justify-content-center
            "
          >
            <div class="reminder-head-txt">
              Send a Reminder to Panelist for Face to Face round
            </div>
            <div class="reminder-sub-txt mt-1">
              Panelist will get a reminder to fill feedback form
            </div>
            <div class="bluebtn mt-2 mb-2 position-relative">
              <b-button
                class="acs-addBtn-modal w-105px"
                :class="showLoader ? 'send-loader-class' : ''"
                @click="showLoader ? '' : sendRemainder()"
                >{{ showLoader ? "" : "Send" }}</b-button
              >
              <div v-if="showLoader" class="send-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mt-3 d-flex flex-column p-3">
            <div class="reminder-head-txt">
              Send a Reminder to Panelist for Face to Face round
            </div>
            <div class="reminder-sub-txt mt-1">
              Panelist will get a reminder to fill feedback form
            </div>
            <div class="ihd-ip-container mt-3">
              <div class="reminder-head-txt mb-2">Panelist</div>
              <div
                class="
                  createjob-ip-evaluators
                  gap-10
                  d-flex
                  flex-wrap
                  align-items-center
                "
                v-for="panel in panelistArray"
                :key="panel.value"
              >
                {{ panel.text }}
              </div>
            </div>
            <div class="ihd-ip-container mt-3">
              <div class="ihd-ip-mainhead">History</div>
              <div
                v-for="(rem, index) in remainders"
                :key="'rem' + index"
                class="mt-3 d-flex align-items-center w-100"
              >
                <div class="position-relative">
                  <div class="ihd-ip-side-circle"></div>
                  <div
                    style="height: 145%"
                    v-if="index < remainders.length - 1"
                    class="ihd-ip-side-line"
                  ></div>
                </div>
                <div class="d-flex justify-content-between ml-3 w-90">
                  <div class="ihd-ip-main-head mt-0">
                    <span class="kanban-reminder-date"> Remainder -</span>
                    {{ index == 0 ? "Sent" : "Resent" }}
                  </div>
                  <div class="kanban-reminder-date" v-if="rem.createdAt">
                    {{ rem.createdAt.slice(0, 10) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div v-else class="p-3">
        <div class="position-relative" v-if="showRecOptions">
          <SelectCustom
            :mandatory="true"
            :placeholder="'Select'"
            :values="getFilteredRecOptions"
            :dropdown="true"
            @select-value="
              (feedback.recOption = $event),
                (feedback.recommendation =
                  thirdPartyData.configuration.recommendationKey[$event])
            "
            :vmodel="$v.feedback.recOption.$model"
            :label="'Recommendation'"
            :showError="$v.feedback.recOption.$error"
          />
          <div v-if="$v.feedback.recOption.$error" class="error-txt-tc">
            Required
          </div>
        </div>
        <div v-else>
          <div class="kanban-recom-txt">
            Recommendation<span class="asterik">*</span>
          </div>
          <div
            class="allocateradios d-flex align-items-ce nter mt-3"
            :class="
              $v.feedback.recommendation.$error ? 'recomendation-error' : ''
            "
          >
            <b-form-radio
              v-if="
                selectedProcess.id != 'F' &&
                totalNoOfRounds - 4 > parseInt(selectedCandidate.kanbanLevel) &&
                !roles.includes('GET_VENDOR_DASHBOARD')
              "
              v-model="feedback.select"
              value="SE"
              @change="changeRec"
              >Select</b-form-radio
            >
            <b-form-radio
              v-else-if="!roles.includes('GET_VENDOR_DASHBOARD')"
              v-model="feedback.recommendation"
              value="S"
              @change="changeRec"
              >{{
                selectedProcess.id == "H" ? "Select" : "Final Select"
              }}</b-form-radio
            >
            <b-form-radio
              v-else
              v-model="feedback.recommendation"
              value="S"
              @change="changeRec"
              >{{
                !checkVendorRounds ? "Select" : "Final Select"
              }}</b-form-radio
            >
            <b-form-radio
              v-if="selectedCandidate.kanbanLevel != 'H'"
              v-model="feedback.recommendation"
              value="H"
              class="ml-3"
              @change="changeSel"
              >Hold</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              value="R"
              class="ml-3"
              @change="changeSel"
            >
              Reject
            </b-form-radio>
            <b-form-radio
              v-model="feedback.recommendation"
              value="NI"
              class="ml-3"
              @change="changeSel"
            >
              Not Interested
            </b-form-radio>
            <b-form-radio
              v-if="selectedCandidate.kanbanLevel != 'H'"
              v-model="feedback.recommendation"
              value="DNA"
              class="ml-3"
              @change="changeSel"
            >
              No Show
            </b-form-radio>
          </div>
        </div>
        <hr class="my-2" />
        <div
          class="allocateradios d-flex align-items-center"
          v-if="showSelOptions"
          :class="
            $v.feedback.recommendation.$error ? 'recomendation-error' : ''
          "
        >
          <b-form-radio v-model="feedback.recommendation" value="S"
            >Select for next round</b-form-radio
          >
          <b-form-radio
            @change="getOpsHead"
            v-model="feedback.recommendation"
            value="FS"
            class="ml-3"
            >Select to Hire</b-form-radio
          >
        </div>
        <div class="mt-3" v-if="feedback.recommendation == 'FS'">
          <SingleSelectSearch
            :label="'Approver (To select this candidate for final selection)'"
            :mandatory="true"
            :showError="$v.selectedOpsHead.$error"
            :opsHeadList="opsHeadList"
            @search-data="searchOpsHead"
            @select-value="selOpsHead"
          />
        </div>
        <div class="newmodalinputbox mt-3">
          <div class="jdk-ip-confirm-subtxt">
            Remarks<span class="asterik">*</span>
          </div>
          <b-form-textarea
            class="overflow-auto"
            rows="2"
            type="text"
            max-rows="5"
            placeholder="Enter"
            v-model.trim="$v.feedback.recruiterRemarks.$model"
            :class="$v.feedback.recruiterRemarks.$error ? 'error' : ''"
          >
          </b-form-textarea>
          <div
            v-if="
              $v.feedback.recruiterRemarks.$dirty &&
              !$v.feedback.recruiterRemarks.required
            "
            class="errortxt mt-1"
          >
            Required
          </div>
          <div
            v-else-if="!$v.feedback.recruiterRemarks.maxLength"
            class="errortxt mt-1"
          >
            Exceeded the max char length of 256
          </div>
        </div>
        <hr class="my-2" />
        <div
          class="kanban-asmnt-container"
          v-if="
            feedbackType == 'eval' &&
            feedback.recommendation != 'NI' &&
            feedback.recommendation != 'DNA' &&
            selectedCandidate.assessmentResponse.status == 2 &&
            selectedCandidate.assessmentResponse.evaluationStatus
          "
        >
          <div
            class="
              kanban-ac-header
              d-flex
              align-items-center
              pl-3
              pr-3
              justify-content-between
            "
          >
            <span>Assessment</span>

            <div
              v-if="
                interviewObject.comparisonScore ||
                interviewObject.comparisonScore == 0
              "
              class="fs-12 font-lato d-flex align-items-center"
            >
              <span class="color-8c8c8c fw-500">Face Match Rating:</span
              >&nbsp;<span class="color-mainblue fw-600"
                >{{ Math.round(interviewObject.comparisonScore) }}%</span
              >
            </div>
          </div>
          <div class="p-3">
            <div
              class="
                kanban-ac-header-bluetxt
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div>
                Total Marks :
                {{ selectedCandidate.assessmentResponse.marks.marksScored }}/
                {{ selectedCandidate.assessmentResponse.marks.totalMarks }}
              </div>
              <div>
                Passing Percentage (%) :
                {{
                  selectedCandidate.assessmentResponse.passingStatus
                    .passingPercentage
                }}/100
              </div>
            </div>
            <div
              v-if="cheatingProbability || cheatingProbability == 0"
              class="kanban-ac-header-bluetxt d-flex align-items-center gap-10"
            >
              Cheating Probability (%):
              <div class="fs-12 fw-500" :class="getColor('color')">
                {{ cheatingProbability }}%
              </div>
              <div
                v-if="
                  particularJob.maxCheatingPercentage ||
                  particularJob.maxCheatingPercentage == 0
                "
                class="metric-spoken-tag fs-11 fw-400 font-inter"
                :class="getColor('bg')"
              >
                {{ getCheatingText }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-3">
              <div>
                <div class="kanban-ac-smalltxt">Sections</div>
              </div>
              <div>
                <div class="kanban-ac-smalltxt">Marks</div>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-between"
              v-for="section in selectedCandidate.assessmentResponse.marks
                .sectionMarks"
              :key="section.sectionID"
            >
              <div>
                <div class="kanban-ac-asmnttxt mt-2">
                  {{ section.sectionName }}
                </div>
              </div>
              <div>
                <div class="kanban-ac-marktxt mt-2">
                  {{ section.sectionMarksScored }}/
                  {{ section.sectionMarksTotal }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            d-flex
            justify-content-center
            align-items-center
            h-100
            flex-column
            mt-5
          "
          v-else-if="
            feedbackType == 'eval' &&
            feedback.recommendation != 'NI' &&
            feedback.recommendation != 'DNA'
          "
        >
          <div>
            <img src="@/assets/img/newkanban/no-assess-data.svg" alt="" />
          </div>
          <span class="color-7a7a7a fs-14 mt-4">No assessment data found</span>
        </div>
        <div
          class="mt-3 extp-basicinfomartion"
          v-if="
            (feedbackType == 'upload' || feedbackType == 'fill') &&
            feedback.recommendation != 'NI'
          "
        >
          <div class="fw-bold newInt-preview-container-head">Basic Info</div>

          <div class="mt-3 d-flex align-items-center">
            <div class="extp-bi-heads" style="width: 40%">Candidate Name</div>

            <div style="width: 60%">
              <b-form-input class="w-100" disabled v-model="basicInfo.name">
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="extp-bi-heads" style="width: 40%">Evaluation Date</div>

            <div style="width: 60%">
              <b-form-input
                class="w-100"
                disabled
                :value="
                  basicInfo.evalDate
                    ? basicInfo.evalDate.replaceAll('/', '-')
                    : basicInfo.evalDate
                "
              >
              </b-form-input>
            </div>
          </div>

          <div class="mt-3 d-flex align-items-center">
            <div class="extp-bi-heads" style="width: 40%">
              Mode Of Interview
            </div>

            <div style="width: 60%">
              <b-form-input class="w-100" disabled v-model="displayMode">
              </b-form-input>
            </div>
          </div>
          <div
            v-if="basicInfo.modeOfInterview == 'assesment'"
            class="mt-3 d-flex align-items-center"
          >
            <div class="extp-bi-heads" style="width: 40%">Panelist</div>

            <div style="width: 60%">
              <b-form-input
                class="w-100"
                disabled
                v-model="basicInfo.panelName"
              >
              </b-form-input>
            </div>
          </div>
          <div class="mt-3 d-flex align-items-center" v-else>
            <div class="extp-bi-heads" style="width: 40%">
              Panelist
              <span class="asterik">*</span>
            </div>

            <div style="width: 60%" class="position-relative">
              <Select
                :id="'access'"
                :dropdownOptions="panelistArray"
                :showError="$v.basicInfo.panelName.$error"
                :disableDropdown="false"
                :value="selectedPanel.value"
                :text="selectedPanel.text"
                :placeholder="'Select Panel'"
                @setValue="updatePanelName"
              />
            </div>
          </div>
          <div
            v-if="
              interviewObject.comparisonScore ||
              interviewObject.comparisonScore == 0
            "
            class="mt-3 d-flex align-items-center"
          >
            <div class="extp-bi-heads" style="width: 40%">
              Identity Match (%)
            </div>

            <div style="width: 60%">
              <b-form-input
                class="w-100"
                disabled
                :value="`${Math.round(interviewObject.comparisonScore)}%`"
              >
              </b-form-input>
            </div>
          </div>
          <div
            v-if="cheatingProbability || cheatingProbability == 0"
            class="mt-3 d-flex align-items-center"
          >
            <div class="extp-bi-heads" style="width: 40%">
              Cheating Probability (%)
            </div>

            <div
              style="width: 60%"
              class="d-flex justify-content-end align-items-center gap-10"
            >
              <div class="fs-16 fw-700" :class="getColor('color')">
                {{ cheatingProbability }}%
              </div>
              <div
                v-if="
                  particularJob.maxCheatingPercentage ||
                  particularJob.maxCheatingPercentage == 0
                "
                class="metric-spoken-tag fs-14 fw-500 font-inter"
                :class="getColor('bg')"
              >
                {{ getCheatingText }}
              </div>
            </div>
          </div>
        </div>
        <!--   :class="input.markingType == 'rating' ? 'pb-0' : ''" -->

        <template
          v-if="
            feedbackType == 'fill' &&
            feedback.recommendation != 'F' &&
            feedback.recommendation != 'NI' &&
            feedback.recommendation != 'DNA'
          "
        >
          <div
            class="mt-3 givefdbck-blue-containers"
            v-for="(skill, index) in fillForm.skills"
            :key="'sk' + index"
            :class="{
              error: $v.fillForm.skills.$each[index].$error,
            }"
          >
            <div class="w-100 exptp-inner-containers-head text-truncate">
              {{ skill.name }}
              <span class="asterik" v-if="skill.mandatory">*</span>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="skill.markingType == 'rating'"
            >
              <div class="newInt-inner-containers-subhead">Rating</div>
              <div class="extpanelist-rating-input">
                <b-form-rating
                  variant="primary"
                  class="newInt-rating p-0 w-25 ml-2"
                  v-model="$v.fillForm.skills.$each[index].mark.$model"
                ></b-form-rating>
              </div>
            </div>

            <div class="mt-2" v-if="skill.markingType == 'score'">
              <div class="topDiv d-flex align-items-center">
                <div>
                  <label class="newInt-inner-containers-subhead">Score</label>
                </div>
                <div class="ml-2">
                  <b-form-input
                    class="h37-w44 newInt-previewInputField"
                    type="number"
                    v-model="$v.fillForm.skills.$each[index].mark.$model"
                    @update="$v.fillForm.skills.$each[index].$touch()"
                    min="0"
                    max="10"
                  >
                  </b-form-input>
                </div>
                <div class="ml-1 newInt-preview-container-subFont">
                  Out of 10
                  <span
                    v-if="!$v.fillForm.skills.$each[index].mark.between"
                    class="error-txt-tc ml-2"
                    >Should be between 1 to 10</span
                  >
                </div>
              </div>
            </div>

            <div class="mt-1" v-if="skill.commentMode">
              <div class="topDiv">
                <div>
                  <label class="newInt-inner-containers-subhead"
                    >Comments</label
                  >
                </div>
                <div class="mt-1">
                  <b-form-textarea
                    class="newInt-previewInputField"
                    rows="3"
                    max-rows="4"
                    v-model="$v.fillForm.skills.$each[index].comments.$model"
                    @update="$v.fillForm.skills.$each[index].$touch()"
                    style="color: #333333"
                  >
                  </b-form-textarea>
                  <div
                    v-if="!$v.fillForm.skills.$each[index].comments.maxLength"
                    class="error-txt-tc"
                  >
                    Exceeded the max char length of 124
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- please note the heading shuld be visible when u upload screenshot n feedback  -->
        <div
          class="mt-3 givefdbck-blue-containers"
          v-if="
            feedbackType == 'upload' &&
            feedback.recommendation != 'NI' &&
            feedback.recommendation != 'DNA'
          "
        >
          <div class="exptp-inner-containers-head">
            Feedback Form<span
              v-if="selectedCandidate.kanbanLevel != 'F'"
              class="asterik"
              >*</span
            >
            <template v-if="feedbackform == null || feedbackform.length == 0">
              <div
                class="mt-2 relativeclass jdkanban-upload-file"
                :class="
                  $v.feedbackform.$error || invalidFile || maxSize
                    ? 'newuploaderror newUploadDoc'
                    : 'newUploadDoc'
                "
                v-b-tooltip.hover.html.bottom
                :title="tooltipContent"
              >
                <b-form-file
                  ref="uploadFiles"
                  id="feedback"
                  v-model="feedbackform"
                  accept=".pdf,.doc,.docx"
                  @input="uploadFile"
                >
                </b-form-file>
                <div
                  class="
                    d-flex
                    align-items-center
                    flex-column
                    justify-content-center
                    h-100
                    w-100
                  "
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      h-50
                      w-100
                    "
                  >
                    <img
                      src="../../../assets/New-imgs/CustVend-icons/manage-upload-icon.svg"
                      alt=""
                    />
                    <span class="newUploadDoc-innerContent-font-blk ml-2">
                      Drag & Drop or
                    </span>
                    <span class="newUploadDoc-innerContent-font-blue ml-2">
                      Browse file
                    </span>
                  </div>
                  <div
                    class="d-flex align-items-center kanban-upload-failed-text"
                    v-if="invalidFile || maxSize"
                  >
                    <div>
                      <img
                        src="../../../assets/New-imgs/CustVend-icons/uploadfailed.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-1">Upload Failed</div>
                  </div>
                </div>
              </div>
              <div class="kanban-fdbck-validation-msg" v-if="maxSize">
                File limit Exceeded
              </div>
              <div
                class="kanban-fdbck-validation-msg"
                v-else-if="$v.feedbackform.$error"
              >
                Required
              </div>
            </template>
            <div
              v-else
              class="
                d-flex
                align-items-center
                justify-content-between
                mt-2
                w-100
              "
            >
              <div>{{ feedbackform.name }}</div>
              <div class="d-flex">
                <div class="mr-2 position-relative ucdSelDocFile">
                  <img src="../../../assets/img/newkanban/replace.svg" alt="" />
                  <b-form-file
                    ref="uploadFiles"
                    v-model="feedbackform"
                    class="mb-2"
                    accept=".pdf,.doc,.docx"
                    @input="uploadFile"
                  ></b-form-file>
                </div>
                <img
                  @click="feedbackform = []"
                  src="../../../assets/img/newkanban/x-close.svg"
                  alt=""
                  class="pointer"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="mt-3 givefdbck-blue-containers"
          v-if="
            feedback.recommendation != 'NI' &&
            feedbackType == 'upload' &&
            feedback.recommendation != 'DNA'
          "
        >
          <template v-if="screenshot == null || screenshot.length == 0">
            <div class="exptp-inner-containers-head">
              Candidate Screenshot<span
                class="asterik"
                v-if="fillForm.screenshot"
                >*</span
              >
            </div>
            <div
              class="mt-2 relativeclass jdkanban-upload-file"
              :class="
                $v.screenshot.$error || maxSrcSize || invalidScrFile
                  ? 'newuploaderror newUploadDoc'
                  : 'newUploadDoc'
              "
              v-b-tooltip.hover.html.bottom
              :title="screenshotContent"
            >
              <b-form-file
                ref="uploadFiles"
                id="screenshot"
                v-model="screenshot"
                @input="handleImageUpload"
                accept=".jpeg,.png"
              >
              </b-form-file>
              <div
                class="
                  d-flex
                  align-items-center
                  flex-column
                  justify-content-center
                  h-100
                  w-100
                "
              >
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    h-50
                    w-100
                  "
                >
                  <img
                    src="../../../assets/New-imgs/CustVend-icons/manage-upload-icon.svg"
                    alt=""
                  />
                  <span class="newUploadDoc-innerContent-font-blk ml-2">
                    Drag & Drop or
                  </span>
                  <span class="newUploadDoc-innerContent-font-blue ml-2">
                    Browse file
                  </span>
                </div>
                <div
                  class="kanban-upload-failed-text"
                  v-if="invalidScrFile || maxSrcSize"
                >
                  <span>
                    <img
                      src="../../../assets/New-imgs/CustVend-icons/uploadfailed.svg"
                      alt=""
                    />
                  </span>
                  <span class="ml-1"> Upload Failed </span>
                </div>
              </div>
            </div>
            <div class="kanban-fdbck-validation-msg" v-if="maxSrcSize">
              File limit Exceeded
            </div>
            <div
              class="kanban-fdbck-validation-msg"
              v-else-if="$v.screenshot.$error"
            >
              Required
            </div>
          </template>

          <template v-else>
            <div class="d-flex align-items-center justify-content-between">
              <div class="exptp-inner-containers-head">
                <img
                  src="../../../assets/img/newkanban/pssicon.svg"
                  class="mr-2"
                  alt=""
                />
                Candidate Screenshot<span
                  class="asterik"
                  v-if="fillForm.screenshot"
                  >*</span
                >
              </div>
              <div class="d-flex">
                <div class="pointer position-relative ucdSelDocFile mr-1">
                  <img src="../../../assets/img/newkanban/replace.svg" alt="" />

                  <b-form-file
                    @input="handleImageUpload"
                    v-model="screenshot"
                    ref="excel-upload-input"
                    class="mb-2"
                    accept=".jpeg,.png"
                  ></b-form-file>
                </div>
                <img
                  @click="screenshot = []"
                  src="../../../assets/img/newkanban/x-close.svg"
                  alt=""
                  class="pointer"
                />
              </div>
            </div>
            <div class="mt-2 extp-cand-ssbox">
              <img
                :src="imageUrl"
                class="w-100 h-100 overflow-hidden"
                alt=""
              /></div
          ></template>
        </div>
      </div>
    </div>
    <hr class="my-0" />
    <div
      v-if="feedbackType != 'remainder'"
      class="d-flex align-items-center p-2 bluebtn mt-2 mb-2"
      :class="
        showBotAnalysis || showProctoringReport
          ? 'justify-content-between'
          : 'justify-content-end'
      "
    >
      <div
        v-if="showBotAnalysis || showProctoringReport"
        @click="showBotAnalysis ? goToBotAnalysis() : goToProctoring()"
        class="d-flex pointer pl-2"
      >
        <img alt="" class="mr-2" :src="getImgSrc" />
        <div class="fdbk-his-link">
          {{ showBotAnalysis ? "View Bot Analysis" : "View Proctoring Report" }}
        </div>
      </div>
      <div class="d-flex pr-2">
        <b-button class="acs-cancelBtn-modal w-105px mr-3" @click="hideGiveFeed"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal w-105px"
            :class="{
              'FS-loader-class': feedback.recommendation == 'FS' && showLoader,
              'send-loader-class':
                feedback.recommendation != 'FS' && showLoader,
              defaultCursor: showLoader,
              pointer: !showLoader,
            }"
            @click="showLoader ? '' : confirm()"
            >{{
              showLoader
                ? ""
                : feedback.recommendation != "FS"
                ? "Send"
                : "Send for approval"
            }}</b-button
          >
          <div
            v-if="showLoader"
            :class="
              feedback.recommendation == 'FS'
                ? 'FS-loader-pos'
                : 'send-loader-pos'
            "
          >
            <Loader />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="feedbackType == 'remainder' && remainders.length > 0"
      class="d-flex align-items-center p-2 bluebtn mt-2 mb-2"
      :class="
        showBotAnalysis || showProctoringReport
          ? 'justify-content-between'
          : 'justify-content-end'
      "
    >
      <div
        v-if="showBotAnalysis || showProctoringReport"
        @click="showBotAnalysis ? goToBotAnalysis() : goToProctoring()"
        class="d-flex pointer pl-2"
      >
        <img alt="" class="mr-2" :src="getImgSrc" />
        <div class="fdbk-his-link">
          {{ showBotAnalysis ? "View Bot Analysis" : "View Proctoring Report" }}
        </div>
      </div>
      <div class="d-flex pr-2">
        <b-button class="acs-cancelBtn-modal w-105px mr-3" @click="hideGiveFeed"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal w-105px"
            @click="showLoader ? '' : sendRemainder()"
            :class="
              showLoader ? 'resend-loader-class defaultCursor' : 'pointer'
            "
            >{{ showLoader ? "" : "Resend" }}</b-button
          >
          <div v-if="showLoader" class="resend-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  required,
  requiredIf,
  between,
  maxLength,
} from "vuelidate/lib/validators";
import {
  getScheduledInterview,
  getfeedbackforms,
  savefeedbackform,
  getSentHistory,
  panelFeedbackForm,
  getOpsHead,
  movetofinalround,
} from "../../../utils/apiFunctions";
import Select from "../../fixedcomponents/Select.vue";
import { mapGetters } from "vuex";
import Loader from "../../fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";
import SingleSelectSearch from "../../InputComponents/SingleSelectSearch.vue";
import SelectCustom from "../../InputComponents/SelectCustom";

export default {
  name: "GiveFeedBack",
  data() {
    return {
      feedbackType: "",
      imageUrl: "",
      opsHeadSearch: "",
      maxFileSize: 2,
      selectedOpsHead: {},
      maxSize: false,
      maxSrcSize: false,
      invalidScrFile: false,
      invalidFile: false,
      remainder: false,
      showOpsHead: false,
      showLoader: false,
      screenshot: [],
      feedbackform: [],
      remainders: [],
      panelistArray: [],
      opsHeadList: [],
      basicInfo: {},
      fillForm: {},
      interviewObject: {},
      selectedPanel: {},
      feedback: {
        recommendation: "",
        recruiterRemarks: "",
        recOption: "",
      },
      recommendationOptions: [],
    };
  },
  props: {
    isGiveFeedback: Boolean,
    selectedProcess: Object,
    selectedCandidate: Object,
    particularJob: Object,
    totalNoOfRounds: Number,
    vendorRounds: Number,
  },
  mixins: [toast],
  components: {
    Select,
    Loader,
    SingleSelectSearch,
    SelectCustom,
  },
  created() {
    this.getScheduledProcess();
    if (this.selectedProcess.type == "assesment") {
      this.feedbackType = "eval";
    } else {
      this.feedbackType = "upload";
      this.getHistory();
    }
    if (this.showRecOptions) {
      this.recommendationOptions =
        this.thirdPartyData.configuration.feedbackLevelOptions;
    }
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      licenseKey: "getlicenseKey",
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters(["roles"]),
    getCheatingText() {
      let text =
        this.cheatingProbability < this.particularJob.maxCheatingPercentage
          ? "Low Percentage"
          : "High Percentage";
      return text;
    },
    cheatingProbability() {
      if (
        this.interviewObject.assessmentResponse &&
        Object.keys(this.interviewObject.assessmentResponse).includes(
          "cheatingProbability"
        ) &&
        typeof this.interviewObject.assessmentResponse.cheatingProbability ==
          "number"
      )
        return this.interviewObject.assessmentResponse.cheatingProbability;
      return null;
    },
    getImgSrc() {
      let img = this.showBotAnalysis
        ? require("@/assets/img/newkanban/botanalysis.svg")
        : require("@/assets/panelLog/preview_eye.svg");
      return img;
    },
    showProctoringReport() {
      if (this.interviewObject.assessmentResponse)
        return this.interviewObject.assessmentResponse.canViewProctoringReport;
      return false;
    },
    showBotAnalysis() {
      return (
        this.roles.includes("VIEW_CANDIDATE_ANALYSIS") &&
        this.interviewObject.botInfo?.botAnalysisCompleted
      );
    },
    displayMode() {
      if (this.basicInfo.modeOfInterview == "f2f") {
        return "Face to Face";
      }
      return "Assessment";
    },
    tooltipContent() {
      return `Upload feedback<br>(.doc, .docx, .pdf) max 2mb`;
    },
    screenshotContent() {
      return `Upload screenshot<br>(.png, .jpg, .jpeg) max 2mb`;
    },
    checkVendorRounds() {
      if (
        this.totalNoOfRounds - 5 > this.vendorRounds ||
        this.selectedProcess.id < this.vendorRounds
      ) {
        return false;
      }
      return true;
    },
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    getFilteredRecOptions() {
      return Object.entries(this.recommendationOptions).map(([key, label]) => {
        return { key, label };
      });
    },
    showSelOptions() {
      if (this.roles.includes("GET_VENDOR_DASHBOARD")) return false;
      else if (this.showRecOptions) {
        return (
          ["option1", "option2"].includes(this.feedback.recOption) &&
          this.totalNoOfRounds - 4 >
            parseInt(this.selectedCandidate.kanbanLevel)
        );
      } else {
        return this.feedback.select == "SE";
      }
    },
    botInterview() {
      return this.interviewObject?.interviewRound?.interviewScheduleType == 3;
    },
  },
  validations() {
    return {
      fillForm: {
        skills: {
          $each: {
            comments: {
              required: requiredIf((obj) => obj.commentMode && obj.mandatory),
              maxLength: maxLength(124),
            },
            mark: {
              required: requiredIf(
                (obj) => obj.markingType != "" && obj.mandatory
              ),
              between: between(1, 10),
            },
          },
        },
      },
      feedback: {
        recruiterRemarks: {
          required,
          maxLength: maxLength(256),
        },
        recommendation: {
          required,
        },
        recOption: {
          required: requiredIf(() => {
            return this.showRecOptions;
          }),
        },
      },
      feedbackform: {
        required: requiredIf(() => {
          return this.selectedCandidate.kanbanLevel != "F";
        }),
      },
      screenshot: {
        required: requiredIf(() => {
          return this.fillForm.screenshot;
        }),
      },
      selectedOpsHead: {
        required,
      },
      basicInfo: {
        panelName: {
          required: requiredIf(() => {
            return this.basicInfo.modeOfInterview == "f2f";
          }),
        },
      },
    };
  },
  methods: {
    goToProctoring() {
      const baseUrl = `https://judge.hire3x.com/proctoring/evaluatetest/${this.interviewObject.interviewRound.testID}/${this.interviewObject.interviewRound.topicID}/${this.interviewObject.interviewRound.groupID}/${this.interviewObject.assessmentResponse.userID}/R`;
      const urlWithQuery = `${baseUrl}?attemptNo=${this.interviewObject.assessmentResponse.priorityAttemptID}&fromRec=true`;
      window.open(urlWithQuery, "_blank");
    },
    getColor(type) {
      let value;
      if (
        this.particularJob.maxCheatingPercentage ||
        this.particularJob.maxCheatingPercentage == 0
      ) {
        if (this.cheatingProbability < this.particularJob.maxCheatingPercentage)
          value = type == "color" ? "color-green" : "bg-green color-green";
        else
          value =
            type == "color" ? "color-darkred" : "bg-darkred color-darkred";
      } else {
        value = type == "color" ? "color-mainblue" : "bg-blue color-mainblue";
      }
      return value;
    },
    hideGiveFeed() {
      this.$emit("close-modal");
      if (this.$route.query.givefeed) {
        let newQuery = { ...this.$route.query };
        delete newQuery.givefeed;
        delete newQuery.round;
        delete newQuery.candidateID;
        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
    },
    goToBotAnalysis() {
      let queryData = {
        intid: this.selectedCandidate.kanbanInterviewID,
        type: 1,
        fromkanban: true,
        givefeed: true,
        fromPage: this.$route.name,
        candidateID: this.selectedCandidate.candidateID,
        round: this.selectedCandidate.kanbanLevel,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    searchOpsHead(value) {
      this.opsHeadSearch = value;
      this.getOpsHead();
    },
    selOpsHead(opsHead) {
      this.selectedOpsHead = opsHead;
      this.$forceUpdate();
    },
    async getScheduledProcess() {
      const res = await getScheduledInterview(
        this.selectedCandidate.kanbanInterviewID
      );
      if (res.status == 200) {
        this.interviewObject = res.data.data;

        if (
          this.interviewObject.interviewRound.type == "f2f" ||
          this.selectedProcess.id == "F"
        ) {
          let externalPanelist = this.interviewObject.externalPanelist.map(
            (item) => {
              return { text: item, value: item };
            }
          );

          let internalPanelist = this.interviewObject.panelist
            .filter((panelist) => panelist.name) // Filter out panelists without a name
            .map((panelist) => ({
              text: panelist.name,
              value: panelist.email,
            }));
          this.panelistArray = [...internalPanelist, ...externalPanelist];
        }
        this.fillBasic();
      }
    },
    changeSel() {
      this.feedback.select = "";
      this.$forceUpdate();
    },
    changeRec() {
      if (this.feedback.select == "SE") {
        this.feedback.recommendation = "S";
      } else {
        this.feedback.recommendation = "";
      }
      this.$forceUpdate();
    },
    updatePanelName(data) {
      this.selectedPanel = data;
      this.basicInfo.panelName = this.selectedPanel.text;
    },
    async fillBasic() {
      this.basicInfo = {
        name: this.selectedCandidate.name,
        evalDate: this.getCurrentDate(),
        modeOfInterview: this.interviewObject.interviewRound.type,
        experience: this.selectedCandidate.experince,
        panelName: "",
      };
      if (this.basicInfo.modeOfInterview == "assesment") {
        this.basicInfo.panelName = this.interviewObject.panelist[0].name;
      }
      if (this.panelistArray.length == 1) {
        this.updatePanelName(this.panelistArray[0]);
      }
      let feedbcakformID = this.interviewObject.interviewRound.feedbackFormID;
      if (this.selectedProcess.id != "F") {
        const res = await getfeedbackforms("2", feedbcakformID);
        if (res.status == 200) {
          this.fillForm = res.data.data;
        }
      }
    },
    changeType() {
      this.imageUrl = "";
      // if(feedbackType == '')this.selectedOpsHead = {};
      this.screenshot = [];
      this.feedbackform = [];
      this.invalidFile = false;
      this.invalidScrFile = false;
      this.$v.$reset();
      this.$forceUpdate();
    },
    async getHistory() {
      let payload = {
        interviewID: this.selectedCandidate.kanbanInterviewID,
        remainder: true,
      };
      const res = await getSentHistory(payload);
      if (res.status === 200) {
        this.remainders = res.data.data;
        this.remainder = true;
      }
    },
    getCurrentDate() {
      let today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1; // January is 0!
      let year = today.getFullYear();

      // Add leading zero if day or month is less than 10
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }

      return day + "/" + month + "/" + year;
    },
    handleImageUpload(event) {
      if (event instanceof File) {
        const fileName = event.name;
        const fileSize = event.size;
        const fileExtension = fileName.split(".").pop().toLowerCase();
        const allowedExtensions = ["jpeg", "png"];

        if (allowedExtensions.includes(fileExtension)) {
          if (fileSize > this.maxFileSize * 1024 * 1024) {
            this.maxSrcSize = true;
            this.screenshot = [];
            return;
          } else {
            this.maxSrcSize = false;
            this.invalidScrFile = false;

            const reader = new FileReader();
            reader.onload = () => {
              // Set the imageUrl
              this.imageUrl = reader.result;
            };

            // Read the file
            reader.readAsDataURL(event);
          }
        } else {
          this.screenshot = [];
          this.maxSrcSize = false;
          this.invalidScrFile = true;
        }
      }

      // Log the feedback object
    },
    uploadFile(event) {
      if (event instanceof File) {
        const fileName = event.name;
        const fileSize = event.size;
        const fileExtension = fileName.split(".").pop().toLowerCase(); //
        const allowedExtensions = ["doc", "docx", "pdf"];

        if (allowedExtensions.includes(fileExtension)) {
          if (fileSize > this.maxFileSize * 1024 * 1024) {
            this.feedbackform = [];
            this.maxSize = true;
            return;
          } else {
            this.maxSize = false;
            this.invalidFile = false;
          }
          // const reader = new FileReader();
          // reader.onload = (e) => {
          //   this.$emit("select-value", this.inputData);
          //   this.$emit("reupload-value", true);
          // };
          // reader.readAsBinaryString(event);
        } else {
          this.feedbackform = [];
          this.maxSize = false;
          this.invalidFile = true;
        }
      }
    },
    async sendRemainder() {
      this.showLoader = true;
      let panelEmail = this.panelistArray.map((panelist) => panelist.value);
      let payload = {
        interviewID: this.selectedCandidate.kanbanInterviewID,
        panelEmail: panelEmail,
      };
      if (this.$route.name == "VendorKanban") {
        payload.vendorID = this.$route.params.vendorID;
      }
      const res = await panelFeedbackForm(payload);
      if (res.status == 200) {
        this.showLoader = false;
        this.dynamicToast("success", "Remainder sent successfully", "");
        this.hideGiveFeed();
      }
    },
    async getOpsHead() {
      let payload = {
        licenseKey: this.licenseKey,
        searchQuery: this.opsHeadSearch,
      };
      const res = await getOpsHead(payload);
      if (res.status == 200) {
        this.opsHeadList = res.data.data;
        this.$forceUpdate();
      }
    },
    confirm() {
      this.$v.feedback.$touch();
      this.$v.basicInfo.panelName.$touch();
      let showError = false;
      if (this.feedback.recommendation == "DNA") {
        this.$v.feedback.recruiterRemarks.$touch();
        this.$v.basicInfo.panelName.$touch();
        showError =
          this.$v.feedback.recruiterRemarks.$invalid ||
          this.$v.basicInfo.panelName.$invalid;
        if (!showError) {
          this.showLoader = true;
          this.onlyRemarks();
        }
      } else if (
        this.feedback.recommendation == "NI" ||
        this.feedbackType == "eval"
      ) {
        if (this.feedback.recommendation === "FS") {
          this.$v.selectedOpsHead.$touch();
          if (!this.$v.feedback.$invalid && !this.$v.selectedOpsHead.$invalid) {
            if (this.feedback.recommendation == "NI") {
              this.basicInfo.panelName = this.roleValues.username;
            }
            this.onlyRemarks();
            this.showLoader = true;
          } else showError = true;
        } else {
          if (!this.$v.feedback.$invalid) {
            if (this.feedback.recommendation == "NI") {
              this.basicInfo.panelName = this.roleValues.username;
            }
            this.onlyRemarks();
            this.showLoader = true;
          } else showError = true;
        }
      } else if (this.feedback.recommendation === "FS") {
        this.$v.selectedOpsHead.$touch();
        this.$v.screenshot.$touch();

        var isValid =
          !this.$v.feedback.$invalid &&
          !this.$v.selectedOpsHead.$invalid &&
          !this.$v.basicInfo.panelName.$invalid &&
          !this.$v.screenshot.$invalid;
        var valid;
        if (this.feedbackType === "upload") {
          this.$v.feedbackform.$touch();
          valid = isValid && !this.$v.feedbackform.$invalid;
        } else {
          this.$v.fillForm.skills.$touch();
          valid = isValid && !this.$v.fillForm.skills.$invalid;
        }

        if (valid) {
          if (this.feedbackType == "upload") {
            this.uploadFeedback();
          } else {
            this.fillFeedback();
          }
          this.showLoader = true;
        } else showError = true;
      } else if (this.feedbackType == "upload") {
        this.$v.feedbackform.$touch();
        this.$v.screenshot.$touch();

        if (
          !this.$v.feedback.$invalid &&
          !this.$v.feedbackform.$invalid &&
          !this.$v.screenshot.$invalid &&
          !this.$v.basicInfo.panelName.$invalid
        ) {
          this.uploadFeedback();
          this.showLoader = true;
        } else showError = true;
      } else if (this.feedbackType == "fill") {
        this.$v.fillForm.skills.$touch();

        if (
          !this.$v.feedback.$invalid &&
          !this.$v.fillForm.skills.$invalid &&
          !this.$v.basicInfo.panelName.$invalid
        ) {
          this.fillFeedback();
          this.showLoader = true;
        } else showError = true;
      }
      if (showError) this.errorModal("Please fill all the details!");
    },
    async uploadFeedback() {
      let payload = {
        interviewID: this.selectedCandidate.kanbanInterviewID,
        processedBy: "Recruiter",
        customFeedback: {
          basicInfo: {
            ...this.basicInfo,
          },
        },
        feedbackForm: this.feedbackform,
        candidateImage: this.screenshot,
        createdBy: this.roleValues.userID,
        createdFor:
          this.interviewObject.interviewRound.type == "f2f" ||
          this.selectedProcess.id == "F"
            ? this.selectedPanel.value
            : null,
        ...this.basicInfo,
        ...this.feedback,
      };
      this.sendToApi(payload);
    },
    async fillFeedback() {
      let payload = {
        interviewID: this.selectedCandidate.kanbanInterviewID,
        processedBy: "PanelThruRecruiter",
        customFeedback: this.fillForm,
        feedbackForm: this.feedbackform,
        createdBy: this.roleValues.userID,
        createdFor:
          this.interviewObject.interviewRound.type == "f2f" ||
          this.selectedProcess.id == "F"
            ? this.selectedPanel.value
            : null,
        ...this.basicInfo,
        ...this.feedback,
      };
      payload.customFeedback.basicInfo = this.basicInfo;
      this.sendToApi(payload);
    },
    async onlyRemarks() {
      let payload = {
        interviewID: this.selectedCandidate.kanbanInterviewID,
        processedBy: "Recruiter",
        candidateImage: this.screenshot,
        createdBy: this.roleValues.userID,
        createdFor:
          this.feedback.recommendation == "NI"
            ? this.roleValues.username
            : this.feedback.recommendation == "DNA"
            ? this.basicInfo.panelName
            : null,
        ...this.basicInfo,
        ...this.feedback,
      };
      this.sendToApi(payload);
    },
    async sendToApi(payload) {
      if (this.showRecOptions) {
        payload.feedbackLevelID = this.feedback.recOption;
        payload.feedbackTypeID =
          this.thirdPartyData.configuration.feedbackTypeID;
      }
      delete payload.recOption;
      if (
        payload.candidateImage == null ||
        payload.candidateImage.length == 0
      ) {
        delete payload.candidateImage;
      }
      if (payload.feedbackForm == null || payload.feedbackForm.length == 0) {
        delete payload.feedbackForm;
      }
      let form = new FormData();
      for (var key in payload) {
        if (key == "customFeedback") {
          form.append(key, JSON.stringify(payload[key]));
        } else {
          form.append(key, payload[key]);
        }
      }
      if (this.$route.name == "VendorKanban") {
        form.append("vendorID", this.$route.params.vendorID);
      }
      const res = await savefeedbackform(form);
      if (res.status == 200) {
        if (this.feedback.recommendation == "FS") {
          let payload2 = {
            candidateID: this.selectedCandidate.candidateID,
            customerID: this.particularJob.customerID,
            jobID: this.particularJob.jobID,
            approverUserID: this.selectedOpsHead.userID,
            recruiterRemarks: this.feedback.recruiterRemarks,
          };
          await movetofinalround(payload2);
        }
        this.showLoader = false;
        this.hideGiveFeed();
        this.$emit("update-details");
        if (this.feedback.recommendation == "R") {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been rejected`;
            this.dynamicToast("rejected", `Successfully Rejected`, text);
          });
        } else if (this.feedback.recommendation == "H") {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been moved to on-hold`;
            this.dynamicToast("onhold", `Moved to On-Hold`, text);
          });
        } else if (this.feedback.recommendation == "NI") {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been moved to not-interested`;
            this.dynamicToast("notinterested", `Moved to Not-interested`, text);
          });
        } else if (this.feedback.recommendation == "FS") {
          this.$nextTick(() => {
            var text = `Candidate "${this.selectedCandidate.name}" has been sent for approval.`;
            this.dynamicToast(
              "feedbacksent",
              `Successfully sent feedback`,
              text
            );
          });
        } else {
          this.$nextTick(() => {
            var text = `Feedback has been sent to candidate "${this.selectedCandidate.name}"`;
            this.dynamicToast(
              "feedbacksent",
              `Successfully sent feedback`,
              text
            );
          });
        }
      } else if (res.status == 409) {
        // this.$nextTick(() => {
        this.showLoader = false;
        var text = `Candidate "${this.selectedCandidate.name}" has already been selected for other job`;
        this.dynamicToast("warning", `Candidate Already Selected`, text);
        // });
      } else {
        this.showLoader = false;
        this.errorModal("Something went wrong!");
      }
    },
  },
};
</script>

<style>
.give-feed-radio
  .custom-control-input[disabled]
  ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
  opacity: 0.5;
  border: 2px solid var(--bluetheme);
}
.give-feed-radio .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.5;
}
.recomendation-error .custom-control-label::before {
  border: 1px solid red;
}

.newmodalinputbox .form-control {
  border-radius: 8px;
}

.FS-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 164px;
}
.FS-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 38px;
}

.send-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 80px;
}
.send-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -4px;
}

.resend-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 96px;
}
.resend-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 0px;
}
.kanban-upload-failed-text {
  text-align: center;
  top: 60px;
  color: #eb0002;
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
}
.metric-spoken-tag {
  padding: 4px 8px;
  border-radius: 4px;
}
</style>
